export default __webpack_public_path__ + "static/media/6.7cd00d78.png";